import { SidebarGroup } from './types';
export const module1Name = '1️⃣ - COMECE POR AQUI';


export const boasVindasSidebar: SidebarGroup[] = [
  {
    title: 'BOAS-VINDAS',
    countLabel: '13 aulas',
    items: [
      { label: 'Comece por aqui', href: '/area/produto/item/2078932' },
      { label: 'AULA OBRIGATÓRIA', href: '/area/produto/item/3893602' },
      { label: 'Qual é a Melhor Corretora?', href: '/area/produto/item/2084276' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234412' },
      { label: 'Responda essa pesquisa rápida sobre você', href: '/area/produto/item/5472583' },
      { label: 'Grupo de Sinais e Operações Ao Vivo', href: '/area/produto/item/2084095' },
      { label: 'Grupo de Avisos e Atualizações', href: '/area/produto/item/3893603' },
      { label: 'Me Siga nas Redes Sociais', href: '/area/produto/item/3893604' },
      { label: 'Como serão as aulas gravadas e ao vivo', href: '/area/produto/item/2084096' },
      { label: 'Tudo sobre as atualizações', href: '/area/produto/item/2084274' },
      { label: 'Não será fácil', href: '/area/produto/item/2084275' },
      { label: 'Aprenda e Lucre com nossos Sinais Ao Vivo', href: '/area/produto/item/5234414' },
      { label: 'Recado Importante', href: '/area/produto/item/5234416' },
    ],
  },
  {
    title: 'SALA DE SINAIS AO VIVO',
    countLabel: '3 aulas',
    items: [
      { label: 'Aprenda e Lucre com nossos Sinais Ao Vivo', href: '/area/produto/item/5234447' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234448' },
      { label: 'Recado Importante', href: '/area/produto/item/5234449' },
    ],
  },
  {
    title: 'COMEÇANDO NAS OPÇÕES BINÁRIAS',
    countLabel: '9 aulas',
    items: [
      { label: 'O que são as Opções Binárias?', href: '/area/produto/item/2078941' },
      { label: 'Corretoras de Opções Binárias', href: '/area/produto/item/2079344' },
      { label: 'Melhor Corretora Atualmente', href: '/area/produto/item/2079345' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5232904' },
      { label: 'Aprenda e Lucre com nossos Sinais Ao Vivo', href: '/area/produto/item/5472570' },
      { label: 'O que é Payout, Tempo de vela, Tempo de Expiração e Livro de Ordens', href: '/area/produto/item/2079346' },
      { label: 'O que são Ativos, Indicadores e Ferramentas Gráficas', href: '/area/produto/item/3893608' },
      { label: 'Mercado Aberto e OTC', href: '/area/produto/item/2079348' },
      { label: 'Recado Importante', href: '/area/produto/item/5232905' },
    ],
  },
  {
    title: 'A MELHOR CORRETORA',
    countLabel: '9 aulas',
    items: [
      { label: 'A Melhor Corretora de Opções Binárias', href: '/area/produto/item/3893620' },
      { label: 'Vantagens e Benefícios da Corretora xxbroker', href: '/area/produto/item/3893614' },
      { label: 'Criando sua Conta na xxbroker', href: '/area/produto/item/2079350' },
      { label: 'Como Depositar na xxbroker', href: '/area/produto/item/2079351' },
      { label: 'Como Sacar na xxbroker', href: '/area/produto/item/2079352' },
      { label: 'Aprenda e Lucre com nossos Sinais Ao Vivo', href: '/area/produto/item/5472572' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234409' },
      { label: 'Recado Importante', href: '/area/produto/item/5234410' },
    ],
  },
  {
    title: 'PRINCÍPIOS DO TRADER',
    countLabel: '7 aulas',
    items: [
      { label: 'Os 3 Pilares do Trader', href: '/area/produto/item/2084285' },
      { label: 'Os Níveis do Trader', href: '/area/produto/item/2084286' },
      { label: 'Como lucrar com Trade', href: '/area/produto/item/2084289' },
      { label: 'Análise, Filtro e Gatilho', href: '/area/produto/item/3893646' },
      { label: 'Tipos de Análises', href: '/area/produto/item/2084291' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234403' },
      { label: 'Recado Importante', href: '/area/produto/item/5234404' },
    ],
  },
  {
    title: 'MINDSET DO TRADER',
    countLabel: '5 aulas',
    items: [
      { label: 'Impossível lucrar sem Controle Emocional', href: '/area/produto/item/2079374' },
      { label: 'A Importância do Emocional', href: '/area/produto/item/3893644' },
      { label: 'Pré Trade, In Trade e Pós Trade', href: '/area/produto/item/4454332' },
      // { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234406' },
      { label: 'Recado Importante', href: '/area/produto/item/5234407' },
    ],
  },
  {
    title: 'GESTÃO FINANCEIRA',
    countLabel: '5 aulas',
    items: [
      { label: 'A Importância da Gestão Financeira', href: '/area/produto/item/2079373' },
      { label: 'Características da Gestão de Capital', href: '/area/produto/item/3893645' },
      { label: 'Assertividade e Rentabilidade', href: '/area/produto/item/4312953' },
      { label: 'Ganhe R$30 reais agora', href: '/area/produto/item/5234368' },
      { label: 'Recado Importante', href: '/area/produto/item/5234369' },
    ],
  }
];

export const boasVindasArticle: string[] = [
  'Para começar a Lucrar com Opções Binárias é OBRIGATÓRIO que você crie sua conta na Melhor Corretora através do LINK abaixo.',
  '🔥 Crie sua conta na Melhor Corretora: https://xxbroker.com/',
  'Entre no nosso Grupo do Telegram exclusivo para alunos da Trading. Todos os dias de Segunda à Sexta às 10:30 - 12:15 e 19:30 temos LIVES de Operações ao vivo e SINAIS.',
  '🔵 Grupo de Sinais Telegram: http://t.me/trendingbrazil  🔵 Grupo de Avisos Telegram: https://t.me/avisostrending',
  'Queremos preparar o melhor conteúdo possível para nossos alunos, por favor preencha essa pesquisa: https://bit.ly/pesquisa-novo-bc',
  'Siga nosso perfil no instagram para conteúdos e novidades.',
  '🟣 Instagram da Trending: https://bit.ly/insta-trending',
  '🟣 Instagram do Gabriel Moreira Trader: https://instagram.com/Gabriel Moreiratrader',
  '🟣 Instagram do Gabriel Moreira Trader Perfil Reserva: https://www.instagram.com/Gabriel Moreirainvestidor',
];

export const boasVindasVideo = { platform: 'youtube' as const, videoId: 'Z7AlPkKbRIA' };

